module.exports = __webpack_public_path__ + "img/cn.c7415e82.png";